module.exports = __webpack_public_path__ + "static/media/messaging-disabled.7929bdcd.png";